import gql from 'graphql-tag';

import dokkioUserFragment from './dokkioUserFragment';
import remoteItemPermissionCapabilitiesFragment from './remoteItemPermissionCapabilitiesFragment';
import remoteItemShareRoleFragment from './remoteItemShareRoleFragment';

export const remoteItemPermissionFragment = gql`
  fragment remoteItemPermissionFragment on RemoteItemPermission {
    dokkioClass
    email
    permissionID
    name
    remoteUserRemoteID
    remoteItemRemoteID
    role
    dokkioUser {
      ...dokkioUserFragment
    }
    capabilities {
      ...remoteItemPermissionCapabilitiesFragment
    }
    shareRoles {
      ...remoteItemShareRoleFragment
    }
  }
  ${dokkioUserFragment}
  ${remoteItemPermissionCapabilitiesFragment}
  ${remoteItemShareRoleFragment}
`;

export default remoteItemPermissionFragment;
